import React from "react";
import "../DesignerPropertiesPanel.css";

const BaseObjectInfoSection = ({ selectedObject, updateObjectFields }) => {
  return (
    <>
      <div className="dp-field">
        <label className="dp-label">Type</label>
        <input
          value={selectedObject.type}
          disabled
          className="dp-input"
        />
      </div>

      <div className="dp-field">
        <label className="dp-label">Name</label>
        <input
          value={selectedObject.name || ""}
          onChange={(e) =>
            updateObjectFields(selectedObject.id, { name: e.target.value })
          }
          className="dp-input"
        />
      </div>
    </>
  );
};

export default BaseObjectInfoSection;